<template>
    <div
        v-if="content.type === 'title'"
        class="py-4 px-4"
    >
        <v-card-title class="py-0 px-0">
            {{ content.text }}
        </v-card-title>
        <v-divider v-if="!content.noDivider" />
    </div>
    <WebPImage 
        v-else-if="content.type === 'title_image'" 
        :src-without-file-type="content.image"
        :available-file-types="content.fileTypes"
        :max-height="imageMaxHeight" 
        :class="'mb-4 ' + getYAlignment(content.alignY)"
        :position="this.positionX + ' ' + this.positionY"
    >
        <v-card-title
            :class="'py-4 px-4 ' + getXAlignment(content.alignX)"
            :style="{color: content.textColor}"
        >
            {{ content.text }}
        </v-card-title>
    </WebPImage>
</template>

<script>
import WebPImage from "@/components/WebPImage.vue";

export default {
    components: {
        WebPImage
    },
    props: ["content"],
    data: () => ({
        positionX: "center",
        positionY: "center"
    }),
    computed: {
        imageMaxHeight: function() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs': return this.content.height * 0.6;
            case 'sm': return this.content.height * 0.75;
            default: return this.content.height;
            }
        }
    },
    methods: {
        getYAlignment(alignY) {
            let align;

            switch(alignY) {
            case "top":
                align = "start";
                this.positionY = "top";
                break;
            case "center":
                align = "center";
                this.positionY = "center";
                break;
            default:
                align = "end";
                this.positionY = "bottom";
                break;
            }

            return (align ? "align-" + align : "");
        },

        getXAlignment(alignX) {
            let justify;

            switch(alignX) {
            case "right":
                justify = "end";
                this.positionX = "right";
                break;
            case "center":
                justify = "center";
                this.positionX = "center";
                break;
            default:
                justify = "start";
                this.positionX = "left";
                break;
            }

            return (justify ? "justify-" + justify : "");
        }
    }
}
</script>